export default __webpack_public_path__ + "static/media/Megatendencias_HeaderESP_2.c96eedd2.jpg";